<template>
    <div class="charts">
		<div class="charts__title charts-title" v-show="getTitle">
			<div class="charts-title__elem text-uppercase">
				График Баланс/Средства
			</div>

			<router-link :to="{name: 'chart' , query: { chart: 'chart' }}" target="_blank" class="charts-title__elem charts-title__elem--right">
				<i v-show="!fullStatus && !mini" class="icon-fullscreen"></i>
			</router-link>
		</div>
		<div class="chart charts__body">
            <transition
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">
                <notif v-if="noti" :currency  = "symbol"></notif>
            </transition>
			<div class="chart__info">
				<sum-data :symbol="symbol" :menu="periodMenu" @setYear = "changeYear($event)" :fullStatus="fullStatus">
				</sum-data>
			</div>
			<div class="chart__item chart__item--h70 echarts">
				<chart-profit
					:update="update"
					:updateRight="updateRight"
					:updateHeight="updateHeight"
					:symbol="symbol"
					:resize="resize"
					:year="year">
				</chart-profit>
			</div>

            <div class="navWidget">
                <div v-for="(item,index) in navigateMenu" :key="index" :class="activeIndexNavigateMenu === index ? 'navWidget-item navWidget-itemActive' : 'navWidget-item'" @click="setActiveWidget(index)">
                    {{item}}
                </div>
            </div>
            <div class="chart__item chart__item--h30 echarts" v-if="activeIndexNavigateMenu === 1">
				<ProfitTable />
            </div>
            <div class="chart__item chart__item--h30 echarts" v-if="activeIndexNavigateMenu === 0">
				<ProfitGistogramm />

                <!--<chart-maxdd
                    :update="update"
                    :updateRight="updateRight"
                    :updateHeight="updateHeight"
                    :symbol="symbol"
                    :resize="resize"
                    :year="year">
                </chart-maxdd>-->

            </div>
        </div>
    </div>
</template>
<script>
import ChartProfit from './sig-profitability-chart';
import ChartMaxdd from './sig-profitability-chart-maxdd';
import SummaryDate from './sig-summary-account-data';
import Notifications from '../header/sig-notifications-on-chart';
import ProfitGistogramm from './chartsForTabs/pofitInPercent/profit-gistagramm';
import ProfitTable from '../statistica/sig-year-profit'
export default {
    data() {
        return {
            year:null,
            navigateMenu:['ДОХОД В % ПО МЕСЯЦАМ','Таблица дохода'],
            activeIndexNavigateMenu:0,
        }
    },
    props: {
        update:{default:true},
        updateRight:{default:true},
        updateHeight:{default:true},
        resize:{default:true},
        symbol:{default:''},
        noti:{default:true},
        currency:{default:''},
        periodMenu:{default:true},
        fullStatus:{default:false},
        mini:{default:false}
    },
    components: {
        "chart-profit":ChartProfit,
        "chart-maxdd":ChartMaxdd,
        "sum-data":SummaryDate,
        "notif":Notifications,
        ProfitGistogramm,
        ProfitTable
    },
    computed: {
        getTitle() {
            return (this.symbol == '') ? true : false;
        }
    },
    methods: {
        changeYear(event) {
            if(event === 'Весь период') {
                this.year=null;
            } else {
            this.year = event;
            }
        },
        setActiveWidget(index) {
            this.activeIndexNavigateMenu = index;
        },
    }
}
</script>
<style lang="less" scoped>
.chart__item--h70 {
	background-image: linear-gradient(0deg,rgba(54,226,255,.4),rgba(0,175,255,0));
}
.icon-fullscreen {
	font-size: 23px;
	color: #aabed2;
}
.charts-title__elem--right {
	margin-right: 23px;
}
.chart__noti {
    position: absolute;
    top:170px;
    left: 8px;
    z-index: 3;
}

.navWidget {
    display: flex;
    min-height: 40px;
    align-items: center;
    &-item {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        color: #adc4e1;
        text-transform: uppercase;
        padding: 14px 12px 0 12px;
        box-sizing: border-box;
        cursor: pointer;
        height: 100%;
    }
    &-itemActive {
        background: #374b62;
        color:#fff;
    }
}

</style>
